import { iconColorTypes, settingsIconTypes } from 'global/enums/settingsIconTypes'
import _ from 'lodash'
import { useMemo } from 'react'
import { Icon } from 'semantic-ui-react'

export const IconSelect = ({ items, dataItem }) => {

  const getColor = (item) => {
    if (!dataItem) return iconColorTypes?.[item] || 'blue';
    return dataItem?.[item] ? iconColorTypes?.[item] : 'grey'
  }

  const icons = useMemo(() => {
    const _icons = _.map(items, (item, key) => {
      if (dataItem[item]) {
        return <Icon
          key={key || item}
          name={settingsIconTypes?.[key || item] || 'cog'}
          color={getColor(item)}
        />
      }
    })
    return _icons
  }, [items, dataItem])

  return (
    <div style={{ alignSelf: 'center' }}>{icons}</div>
  )
}
